import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Tenant } from '@core/model';
import { HomeService } from '@core/service/home.service';
import { ProviderAccountDTO } from '@mynexus/mynexus-ui-lib';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-validate-tax-modal',
    templateUrl: './validate-tax-modal.component.html',
    styleUrls: ['./validate-tax-modal.component.scss'],
    standalone: false
})
export class ValidateTaxModalComponent implements OnInit {
  providers: ProviderAccountDTO[] = null;
  tenant: Tenant = null;

  validateProviderForm = new FormGroup({
    npi: new FormControl({ value: null, disabled: true }),
    taxId: new FormControl(null, [Validators.required])
  });

  get taxId(): AbstractControl {
    return this.validateProviderForm.get('taxId');
  }

  isLoading = false;

  constructor(
    private homeService: HomeService,
    private messageService: MessageService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
  }

  ngOnInit(): void {
    const { data } = this.config;
    this.providers = data.providers;
    this.tenant = data.tenant;

    this.validateProviderForm.get('npi').setValue(this.providers[0].npi);
  }

  close() {
    this.ref.close();
  }

  add() {
    this.validateTaxId();
  }

  private validateTaxId() {
    const providersToValidate = this.providers.filter((p) => p.taxId === this.taxId.value);

    const requests = providersToValidate.map(p =>
      this.homeService.validateProviderTax(p.providerAccountId, this.taxId.value, this.tenant.tenantId)
    );

    this.isLoading = true;

    forkJoin(requests)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: results => {
          const isValid = results.every(Boolean);

          if (!isValid) {
            this.taxId.setErrors({ taxIdMatch: true });

            return;
          }

          this.ref.close(providersToValidate);
        },
        error: () =>
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `Can't validate provider Tax ID. Please contact Carelon support`
          })
      });
  }
}
